import PersistLink from './PersistLink';
export default PersistLink;



// WEBPACK FOOTER //
// ./src/components/common/PersistLink/index.js